export default "__VITE_ASSET__BsRkldXa__"